<div class="text-left">
  <div class="flex bg-secondary text-foreground px-5 py-2 rounded w-[19rem] drop-shadow-lg">
    <select class="bg-secondary appearance-none flex-grow" (input)="onChange($event)" [(ngModel)]="value">
        <option [value]="option.Value" *ngFor="let option of this._options">{{option.Name}}</option>
    </select>
    <fa-icon [icon]="faChevronDown" class="text-sm leading-none absolute w-0 right-7 top-1/3"></fa-icon>
  </div>
</div>
